export const TYPE = {
  number: 'number',
  string: 'string',
  boolean: 'boolean',
  object: 'object',
  array: 'array',
  any: 'any',
};

export const useKeyChainSymbol = Symbol('#useKeyChainSymbol');
